module.exports = __webpack_public_path__ + "img/icon_tt_file.91c12741.svg";